// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { Component } from 'react';
export class Button extends Component {
    constructor(props) {
        super(props);
        this.onMouseClick = this.onMouseClick.bind(this);
    }
    onMouseClick(event) {
        this.props.onClick(event);
        event.stopPropagation();
        event.preventDefault();
    }
    render() {
        if (!this.props.visible) {
            return null;
        }
        const { children, buttonStyle, additionalClass, onOver, onLeave, enabled, checked, tooltip, SVG, name, text, image } = this.props;
        const buttonClass = `terceraButton ${buttonStyle} ${additionalClass}`;
        return (React.createElement("div", { className: `${buttonClass}${!enabled ? ' disabled' : ''}${checked ? ' checked' : ''}`, onClick: this.onMouseClick, onMouseOver: onOver, onMouseLeave: onLeave, "data-tooltip": tooltip },
            SVG && (React.createElement("svg", null,
                React.createElement("use", { xlinkHref: `assets/webdesktop/web-desktop-sprite.svg#${name}` }))),
            image && React.createElement("div", { className: "icon" }, image),
            text && React.createElement("div", { className: "js-text" }, text),
            children,
            !enabled && React.createElement("div", { className: "js-disabled-icon" })));
    }
}
Button.defaultProps = {
    text: '',
    buttonStyle: 'js-button-gray25',
    checked: false,
    visible: true,
    enabled: true,
    additionalClass: ''
};
